import React from 'react';
import { useTranslation } from 'react-i18next';

import { Form, FormGenerator } from '@/shared/ui';
import { Dialog } from '@/shared/ui/Dialog';
import { FormFieldValues } from '@/shared/ui/FormGenerator';
import { Button } from '@/shared/ui/lib/Button';

import { changePhoneSchema } from '../model/schemas';
import {
  ChangePhoneDialogProps,
  ChangePhoneFormDataType,
} from '../model/types';
import { useUpdateAccountSettings } from '../model/useUpdateAccountSettings';

const CHANGE_PHONE_FORM = 'changePhoneForm';
const CHANGE_PHONE_FORM_DIALOG = 'changePhoneFormDialog';

export const ChangePhoneDialog = ({
  open,
  onClose,
}: ChangePhoneDialogProps) => {
  const { t } = useTranslation();
  const { updateAccountSettings, isPending } = useUpdateAccountSettings();

  const formScheme = [
    {
      name: 'phone',
      label: t('common:inputs.phoneNumber'),
      type: FormFieldValues.Phone,
    },
  ];

  const handleCloseDialog = () => {
    onClose?.();
  };

  const handleSubmit = async (data: ChangePhoneFormDataType) => {
    await updateAccountSettings(data);
    handleCloseDialog();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      id={CHANGE_PHONE_FORM_DIALOG}
      title={t('settings:changePhone.title')}
      leftButtonSlot={
        <Button
          onClick={handleCloseDialog}
          variant="outlined"
          disabled={isPending}
        >
          {t('common:buttons.cancel')}
        </Button>
      }
      rightButtonSlot={
        <Button
          type="submit"
          form={CHANGE_PHONE_FORM}
          variant="contained"
          color="primary"
          disabled={isPending}
        >
          {t('common:buttons.save')}
        </Button>
      }
    >
      <Form
        id={CHANGE_PHONE_FORM}
        schema={changePhoneSchema(t)}
        onSubmit={handleSubmit}
        defaultValues={{
          phone: '',
        }}
        mode="onChange"
        sx={{ maxWidth: '400px' }}
      >
        <FormGenerator formScheme={formScheme} />
      </Form>
    </Dialog>
  );
};
